const carLogos = [{ 'Alfa Romeo': 'https://seeklogo.com/images/A/alfa-romeo-logo-3E9AF560E2-seeklogo.com.png' },
  { Ferrari: 'https://seeklogo.com/images/F/ferrari-logo-C75D80471C-seeklogo.com.png' },
  { Dodge: 'https://seeklogo.com/images/D/Dodge-logo-06B7E884FC-seeklogo.com.png' },
  { Subaru: 'https://seeklogo.com/images/S/Subaru-logo-E7467F601A-seeklogo.com.jpg' },
  { Toyota: 'https://seeklogo.com/images/T/toyota-logo-08A29AEE08-seeklogo.com.png' },
  { Volkswagen: 'https://seeklogo.com/images/V/Volkswagen-logo-9A1203CE20-seeklogo.com.png' },
  { Volvo: 'https://seeklogo.com/images/V/volvo-logo-C0F7715FCB-seeklogo.com.png' },
  { Audi: 'https://seeklogo.com/images/A/Audi-logo-A172888F41-seeklogo.com.png' },
  { BMW: 'https://seeklogo.com/images/B/bmw-logo-F4A92B9BC1-seeklogo.com.png' },
  { Buick: 'https://seeklogo.com/images/B/buick-logo-6E3BF13C83-seeklogo.com.jpg' },
];

export default carLogos;
